// src/redux/utilsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const utilsSlice = createSlice({
  name: 'utils',
  initialState: {
    lastBasePoint: { x: 0, y: 0 },
    updateCounter: 0,
    sitePlan: {},
    // Save anında her kat planı documentGroup'unun world origin'i.
    // { [floorPlanId]: { x, y } }. Reload sonrasi current origin vs saved
    // delta hesaplanir, tesisat pozisyonlari bir kere shift'lenir
    // (kat planina cakili gorunum icin). useFloorPlanShiftCorrection.
    floorPlanOriginsAtSave: {},
    // { [floorPlanId]: { x, y, z } }. fpGroup'un fpMesh icindeki local pozisyonu.
    // Load sirasinda setupKatPlani'da bbox yerine bu pozisyon kullanilir,
    // DXF non-determinizmi kaynakli kayma engellenir.
    fpGroupLocalPositions: {},
    // Correction uygulandiktan sonra true. Ayni session'da tekrar uygulanmaz.
    floorPlanShiftCorrected: false,
  },
  reducers: {
    setLastBasePoint: (state, action) => {
      state.lastBasePoint = action.payload;
    },
    addSitePlan: (state, action) => {
      state.sitePlan = action.payload;
    },
  incrementUpdateCounter: (state) => {
      state.updateCounter += 1;
    },
    setFloorPlanOriginsAtSave: (state, action) => {
      state.floorPlanOriginsAtSave = action.payload || {};
    },
    markFloorPlanShiftCorrected: (state) => {
      state.floorPlanShiftCorrected = true;
    },
  },
});

export const {
  setLastBasePoint,
  incrementUpdateCounter,
  addSitePlan,
  setFloorPlanOriginsAtSave,
  markFloorPlanShiftCorrected,
} = utilsSlice.actions;
export default utilsSlice.reducer;
